/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Publish_Visibilityfailed1Inputs */

const zh_publish_visibilityfailed1 = /** @type {(inputs: Publish_Visibilityfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新可见性失败`)
};

const en_publish_visibilityfailed1 = /** @type {(inputs: Publish_Visibilityfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update visibility`)
};

const es_publish_visibilityfailed1 = /** @type {(inputs: Publish_Visibilityfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al actualizar visibilidad`)
};

/**
* | output |
* | --- |
* | "Failed to update visibility" |
*
* @param {Publish_Visibilityfailed1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const publish_visibilityfailed1 = /** @type {((inputs?: Publish_Visibilityfailed1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_Visibilityfailed1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_publish_visibilityfailed1(inputs)
	if (locale === "en") return en_publish_visibilityfailed1(inputs)
	return es_publish_visibilityfailed1(inputs)
});
export { publish_visibilityfailed1 as "publish_visibilityFailed" }